import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Column, Typography } from 'seagull';
import ConfirmExternallySignModal from '~/components/ConfirmExternallySignModal/ConfirmExternallySignModal';
import { RelationshipErrorResponse } from '~/infra/error-response/RelationshipErrorResponse';
import { bulkExternallySignErrorText } from './DraftsDashboard.utils';
const failedSelection = (failedDraftIds)=>failedDraftIds.reduce((acc, draftId)=>_object_spread_props(_object_spread({}, acc), {
            [draftId]: true
        }), {});
const republishRefusalText = (err, errorTexts, legalTermsDocuments)=>{
    var _republishRefusalMessage;
    return (_republishRefusalMessage = new RelationshipErrorResponse(err).republishRefusalMessage(errorTexts, legalTermsDocuments)) !== null && _republishRefusalMessage !== void 0 ? _republishRefusalMessage : errorTexts.relationship.internalError();
};
const createRefusalText = (err, errorTexts, legalTermsDocuments)=>new RelationshipErrorResponse(err).message(errorTexts, legalTermsDocuments);
export const bulkSendAction = (param)=>{
    let { selectedDrafts, draftsTexts, DraftsDashboardTID, drafts, errorTexts, api, createRelationshipFromDraft, republishRelationship, handlePromise, setSelected } = param;
    const draftInfo = (draftId)=>{
        var _draft_contactDetails;
        const draft = drafts.find((draft)=>draft.id === draftId);
        const email = draft === null || draft === void 0 ? void 0 : (_draft_contactDetails = draft.contactDetails) === null || _draft_contactDetails === void 0 ? void 0 : _draft_contactDetails.email;
        return "".concat(draft ? draft.title : draftsTexts.draftFallback()).concat(email ? " (".concat(email, ")") : '');
    };
    const publish = (draftId, draft)=>{
        var _ref, _ref1;
        const linkedRelationshipId = (_ref = draft === null || draft === void 0 ? void 0 : draft.linkedRelationshipId()) !== null && _ref !== void 0 ? _ref : null;
        const legalTermsDocuments = (_ref1 = draft === null || draft === void 0 ? void 0 : draft.legalTermsDocuments()) !== null && _ref1 !== void 0 ? _ref1 : [];
        return linkedRelationshipId != null ? republishRelationship(linkedRelationshipId).catch((err)=>{
            throw republishRefusalText(err, errorTexts, legalTermsDocuments);
        }) : createRelationshipFromDraft(draftId).catch((err)=>{
            throw createRefusalText(err, errorTexts, legalTermsDocuments);
        });
    };
    const sendDraft = async (draftId)=>{
        var _ref;
        const draft = await api.draft.getById(draftId).catch(()=>null);
        const emptyReferenceField = (_ref = draft === null || draft === void 0 ? void 0 : draft.emptyReferenceField()) !== null && _ref !== void 0 ? _ref : null;
        if (emptyReferenceField != null) {
            throw "".concat(draftInfo(draftId), " - ").concat(errorTexts.relationship.referenceFieldValueMissing({
                fieldName: emptyReferenceField.name
            }));
        }
        return publish(draftId, draft).catch((reason)=>{
            throw "".concat(draftInfo(draftId), " - ").concat(reason);
        });
    };
    return {
        bulkItemIds: selectedDrafts,
        confirmation: {
            title: draftsTexts.sendProposalsInBulkTitle(),
            primaryButtonLabel: draftsTexts.sendProposalsButton(),
            content: /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            draftsTexts.sendProposalsConfirmationPrefix(),
                            ' ',
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: DraftsDashboardTID.RemoveModalTemplateName(),
                                as: "span",
                                weight: "bold",
                                children: selectedDrafts.length
                            }),
                            ' ',
                            draftsTexts.sendProposalsConfirmationSuffix()
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: draftsTexts.considerSending()
                    })
                ]
            })
        },
        progressTitle: draftsTexts.sendProposalsInBulkTitle(),
        actionName: draftsTexts.sendProposalsActionName(),
        itemName: draftsTexts.sendProposalsItemName(),
        errorExtra: draftsTexts.sendProposalsErrorExtra(),
        canProcessItem: ()=>true,
        processSingleItem: (draftId)=>handlePromise(sendDraft(draftId)),
        onDone: (failedDraftIds)=>setSelected(failedSelection(failedDraftIds))
    };
};
export const bulkExternallySignAction = (param)=>{
    let { selectedDrafts, draftsTexts, api, handlePromise, draftsMap, defaultAgreementTitle, errorTexts, editTableTexts, setSelected } = param;
    return {
        bulkItemIds: selectedDrafts,
        confirmation: {
            renderModal: (p)=>/*#__PURE__*/ _jsx(ConfirmExternallySignModal, _object_spread_props(_object_spread({}, p), {
                    bulkData: {
                        numClients: selectedDrafts.length
                    }
                }))
        },
        progressTitle: draftsTexts.approveOnBehalfProgressTitle(),
        actionName: draftsTexts.approveOnBehalfActionName(),
        progressAction: draftsTexts.approveOnBehalfAction(),
        itemName: draftsTexts.approveOnBehalfItemName(),
        errorExtra: draftsTexts.approveOnBehalfErrorExtra(),
        canProcessItem: ()=>true,
        processSingleItem: (draftId)=>handlePromise(api.relationship.createFromDraft(draftId, {
                externallySign: true
            })),
        getErrorText: (draftId, error)=>bulkExternallySignErrorText(draftsMap.get(draftId), error, defaultAgreementTitle, errorTexts, editTableTexts),
        onDone: (failedDraftIds)=>setSelected(failedSelection(failedDraftIds))
    };
};
export const bulkDiscardAction = (param)=>{
    let { selectedDrafts, draftsTexts, DraftsDashboardTID, api, handlePromise, setSelected } = param;
    return {
        bulkItemIds: selectedDrafts,
        progressAction: draftsTexts.discardAction(),
        confirmation: {
            title: draftsTexts.discardDraftsTitle(),
            primaryButtonLabel: draftsTexts.discardButton(),
            content: /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            draftsTexts.areYouSureDiscardDraftsPrefix(),
                            ' ',
                            /*#__PURE__*/ _jsx(Typography, {
                                testId: DraftsDashboardTID.RemoveModalTemplateName(),
                                as: "span",
                                weight: "bold",
                                children: selectedDrafts.length
                            }),
                            ' ',
                            draftsTexts.areYouSureDiscardDraftsSuffix({
                                count: selectedDrafts.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: draftsTexts.thisActionCannotBeUndone()
                    })
                ]
            })
        },
        progressTitle: draftsTexts.discardDraftsTitle(),
        actionName: draftsTexts.discardActionName(),
        itemName: draftsTexts.discardItemName(),
        canProcessItem: ()=>true,
        processSingleItem: (draftId)=>handlePromise(api.draft.deleteById(draftId)),
        onDone: (failedDraftIds)=>setSelected(failedSelection(failedDraftIds))
    };
};
